import React, {useState, useEffect} from "react";
import AddNewButton from "../Buttons/AddNewButton";
import ViewButton from "../Buttons/ViewButton";
import FilterButton from "../Buttons/FilterButton";
import { db } from "../../firebase";
import {equalTo, onValue, ref, set, query, orderByChild, orderByValue, get, child, remove} from 'firebase/database';
import { async } from "@firebase/util";




const CollectorTable = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [collectors, setCollectors] = useState([]);

    useEffect(() => {
        const fetchColl = async () => {
        try {
            const collRefrence = await ref(db, 'workers');
            onValue(collRefrence, (snapshot) =>{
                if (snapshot.exists) {
                const collsData = (snapshot).val();
                const collsArray = Object.entries(collsData).map(([collId, collector]) => ({
                    id: collId,
                    ...collector,
                }));
                setCollectors(collsArray.reverse());
                setIsLoading(false)
                }
            })
        } catch (error) {
            console.error('Error retrieving bins:', error);
        }
        };

        fetchColl();
    }, []);

    console.log('collectors ==>', collectors)

    const delCollector = async (id) =>{
        console.log(id);
        const collRefrence = await ref(db, 'workers');
        const childRef = child(collRefrence, id);
        await remove(childRef);
        console.log(`child ${id} is removed`)
    }

    // console.log(collectors)
    return (
        <div className="max-w-screen-xl px-4 mx-auto">
            <div className="flex items-center justify-between mb-4 binhead gap-x-10">
                <h3 className="mb-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-white">Collectors</h3>
                <div className="flex-1">
                    {/* <ViewButton innerTxt={"View On Map"}/> */}
                </div>
                <div className="">
                    {/* <FilterButton innerTxt={"Filter"}/> */}
                </div>
            </div>
    
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 border-collapse" >
                    <thead class="text-s text-gray-700  bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sm:rounded-xl border-collapse: separate">
                        <tr className="sm:rounded-xl">
                            <th scope="col" class="px-6 py-3">
                                CollectorId#
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Name
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Email
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Password
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Status
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Route
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Last Updated
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <span class="sr-only">Del</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading? <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">Loading...</td>
                            </tr>
                            :
                            <>
                                {collectors ? collectors.map((collector) => (
                                    <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={collector.id}>
                                        <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{collector.id}</td>
                                        <td class="px-6 py-4">{collector.name}</td>
                                        <td class="px-6 py-4">{collector.email}</td>
                                        <td class="px-6 py-4">{collector.password}</td>
                                        <td class="px-6 py-4">{collector.status}</td>
                                        <td class="px-6 py-4">{collector.assignedRoute.assignedRouteId ? collector.assignedRoute.assignedRouteId[0]: 'none'}</td>
                                        <td class="px-6 py-4">{collector.lastUpdated ? collector.lastUpdated: 'none'}</td>
                                        <td class="px-6 py-4 text-right">
                                            <a href="" onClick={(e)=>{
                                                e.preventDefault()
                                                const id = collector.id;
                                                delCollector(id);
                                            }} class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Del</a>
                                        </td>
                                    {/* Add more table cells for additional bin properties */}
                                    </tr>
                                    ))
                                    :

                                    <tr class="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                        <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">No Collectors Available</td>
                                    </tr>
                                }
                            </>
                        }
                        
                    </tbody>
                </table>
            </div>


        </div>
    )
}

export default CollectorTable